/*
This file is for handle Recorder.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import Element from './../Element';
import View from './../View';


const Recorder = (spec) => {
    const view = View({});
    const that = {};
    that.recorder = Element({ name: 'i', title: 'record', class: `fa fa-circle fa-fw fa-lg icon_record ${spec.skin}_icon ${spec.skin}_icon_record` });

    that.recorder.onclick = function (e) {
        Recorder.click(e, spec.stream);
    };
    return that.recorder;
};
Recorder.click = function (e, stream) {
    const className = e.currentTarget.classList;
    if (className.contains('fa-circle')) {
        e.currentTarget.classList.remove('fa-circle');
        e.currentTarget.classList.add('fa-stop-circle');
        if (!stream.local) {
            stream.room.startRecording(stream, (id) => {
            });
        } else {
        }
    } else if (className.contains('fa-stop-circle')) {
        e.currentTarget.classList.remove('fa-stop-circle');
        e.currentTarget.classList.add('fa-circle');
        if (stream.recordingId) {
            stream.room.stopRecording(stream.recordingId, (bool) => {
                if (bool) { stream.recordingId = undefined; }
            });
        }
    }
};
export default Recorder;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/Recorder.js
// module id = 184
// module chunks = 0